"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.play_circle = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var play_circle = function play_circle(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'play-circle-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M10 4.08325C6.54822 4.08325 3.75 6.88147 3.75 10.3333C3.75 13.785 6.54822 16.5833 10 16.5833C13.4518 16.5833 16.25 13.785 16.25 10.3333C16.25 6.88147 13.4518 4.08325 10 4.08325ZM2.25 10.3333C2.25 6.05305 5.71979 2.58325 10 2.58325C14.2802 2.58325 17.75 6.05305 17.75 10.3333C17.75 14.6135 14.2802 18.0833 10 18.0833C5.71979 18.0833 2.25 14.6135 2.25 10.3333Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M11.4767 10.3333L9 8.91802V11.7485L11.4767 10.3333ZM12.9806 11.2015C13.6524 10.8176 13.6524 9.8489 12.9806 9.46501L8.99614 7.18819C8.32948 6.80724 7.5 7.28861 7.5 8.05643V12.6101C7.5 13.3779 8.32948 13.8593 8.99614 13.4783L12.9806 11.2015Z',
    fill: '#4B5563'
  }));
};

exports.play_circle = play_circle;